export default "__VITE_ASSET__ClK02g7m__"